<template>
  <div class="title">
    <span v-for="(item, index) in processString(title)" :key="index">
      {{ item }}
    </span>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
export default {
  mixins: [responsiveMixin],
  components: {},
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  beforeDestroy() { },
  mounted() { },
  methods: {
    processString(input) {
      if (!input) return [""];
      if (input.includes("\n")) {
        return input.split("\n");
      } else {
        return [input];
      }
    }
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>